<div id="custom-tile-modal" class="custom-tile-modal min-w-[70vw] bg-white flex flex-col grow p-6 gap-6 overflow-y-auto max-h-screen box-border">
  <div class="modal-content flex gap-6 justify-between">
    <div id="form-container" class="form-container w-1/2 flex flex-col pr-6 neptune-border-r-1 border-sky-blue">
      <form id="custom-tile-form" (keydown)="keyEvent($event)" class="flex flex-col gap-6">
        
          <!-- Title Field -->
          <div id="title-field" class="neptune-form-field">
            <label for="inputTitle">
              Title (Required)
            </label>
            <input
              type="text"
              id="inputTitle"
              [(ngModel)]="inputTitle"
              name="inputTitle"
              maxlength="50"
              class="!px-4 !py-[6px] placeholder:text-neptune-neutral"
              (input)="textChange()"
              placeholder="Enter Title name"
            />
          </div>

          <!-- Value Pillar -->
          <div id="value-pillar-field" class="neptune-form-field">
            <label for="inputValuePillar">
              Value Pillar (Required)
            </label>
            <select 
              id="inputValuePillar" 
              name="inputValuePillar" 
              [(ngModel)]="inputValuePillar"
              class="!px-4 !py-[6px] !h-9 text-base"
              [ngClass]="inputValuePillar ? 'text-black' : 'text-neptune-neutral'"
              (change)="onValuePillarChange()"
              placeholder="Select Value Pillar"
            >
              <option value="" disabled hidden>Select Value Pillar</option> <!-- This option exists so that the selected value resets (to placeholder) if user clears the form-->
              <option *ngFor="let pillar of TvdValuePillars" value="{{pillar}}" class="text-sm text-black">{{pillar}}</option>
            </select>
          </div>

          <!-- Impact Category Field -->
          <div id="impact-category-field" class="neptune-form-field">
            <label for="inputImpactCategory">
              Impact Category (Required)
            </label>         
            <select 
              id="inputImpactCategory"
              name="inputImpactCategory" 
              [(ngModel)]="inputImpactCategory"
              class="!px-4 !py-[6px] !h-9 text-base"
              [ngClass]="inputImpactCategory ? 'text-black' : 'text-neptune-neutral'"
              (change)="onImpactCategoryChange()"
              placeholder="Select Impact Category"
            >
              <option value="" disabled hidden>Select Impact Category</option> <!-- This option exists so that the selected value resets (to placeholder) as the user changes the Value Pillar selection-->
              <option *ngFor="let impactCategory of TvdImpactCategories" value="{{impactCategory}}" class="text-sm text-black">{{impactCategory}}</option>
            </select>
          </div>

          
          <!-- Cost Field -->
          <div id="cost-field" class="neptune-form-field">
            <label for="inputCost">
              {{costLabel}} (Required)
            </label>
            <input
              type="text"
              id="inputCost"
              [(ngModel)]="inputCost"
              name="inputCost"
              class="!px-4 !py-[6px] placeholder:text-neptune-neutral"
              maxlength="20"
              placeholder="Enter Cost"
            />
          </div>

          <!-- Value Field -->
          <div id="value-field" class="neptune-form-field">
            <label for="inputValue">
              {{valueLabel}} (Required)
            </label>
            <input
              type="text"
              id="inputValue"
              [(ngModel)]="inputValue"
              name="inputValue"
              class="!px-4 !py-[6px] placeholder:text-neptune-neutral"
              maxlength="20"
              placeholder="Enter Value"
            />
          </div>

          <!-- Units of Measurement Field -->
          <div id="unit-field" class="neptune-form-field">
            <label for="inputUnit">
              Units of Measurement (Required)
            </label>
            <input
              type="text"
              id="inputUnit"
              [(ngModel)]="inputUnit"
              name="inputUnit"
              class="!px-4 !py-[6px] placeholder:text-neptune-neutral"
              maxlength="100"
              placeholder="Enter an Unit"
            />
          </div>

          
        
      </form>
    </div> 
    <div class="custom-tile-preview flex flex-col w-1/2 gap-6 items-start">
      <p class="text-2xl">Preview</p>
      <div class="relative">
        <div class="preview-tile border-solid border-1 border-sky-blue rounded-[18px] min-w-80">
          <div class="preview-tile-header flex gap-3 justify-start items-center px-6 py-4 min-h-10 neptune-border-b-1 border-sky-blue">
              <img id="preview-icon" src="{{iconPath}}" class="w-9 h-9" alt="tvd-metric-icon">
              <span id="preview-title" class="flex items-center text-2xl text-blue min-h-2xl-clamp">{{inputTitle || '(Title)'}}</span>
          </div>

          <div class="preview-tile-body flex flex-col gap-2 p-6">
              <div class="preview-metric-contributions flex flex-col gap-4">
                  <span id="preview-cost" class="text-4xl font-bold">{{costCurrencyCode | currencySymbol}}{{inputCost || '(Cost)'}}</span>
                  <p class="text-lg"><span id="preview-value" class="font-bold">{{inputValue || '(Value)'}}</span>&nbsp;<span id="preview-units">{{inputUnit || '(Units)'}}</span></p>
              </div>
          </div>
        </div>
        <p class="preview-message absolute left-0 top-full pt-2 text-sm">*A similar tile will appear on both the webpage and the presentation after being saved.</p>
      </div>
      
    </div>
  </div>

  <div id="form-actions" class="flex items-stretch justify-end gap-6 pt-4 neptune-border-t-1 border-shuttle-gray">
      <button type="button" id="btn-clear" class="min-w-24 max-w-24 neptune-button-white" (click)="clickClearButton()">Clear</button>
      <button type="button" id="btn-cancel" class="min-w-24 max-w-24 neptune-button-white" (click)="clickCloseLink()">Cancel</button>
      <button type="button" id="btn-save" class="min-w-24 max-w-24 neptune-button-blue" (click)="clickSaveButton()">Save</button>
  </div>
</div>
